import { Star } from "react-feather";

// Interactive 1-5 star rating. Click a star to set it; click the current value
// again to clear it (null). Shared by the recipe view and the cook-finish prompt;
// matches the star styling used in the recipe editor.
export function StarRating({
  value,
  onChange,
  className = "w-7 h-7",
}: {
  value: number | null | undefined;
  onChange: (rating: number | null) => void;
  // Tailwind size classes for each star (default w-7 h-7 ≈ 28px).
  className?: string;
}) {
  return (
    <div className="flex gap-1.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          aria-label={`${n} star${n > 1 ? "s" : ""}`}
          onClick={() => onChange((value ?? 0) === n ? null : n)}
          className="cursor-pointer"
        >
          <Star
            className={`${className} ${
              (value ?? 0) >= n ? "text-terracotta fill-terracotta" : "text-ink-faint"
            }`}
          />
        </button>
      ))}
    </div>
  );
}

export default StarRating;
